import React from "react";
import { actionTextStatusMap, BRANCH_WHITELISTED_PROVIDERS, QCSTATE_PROVIDERS, STATUS_CODE_MAP, USER } from "../../constants/provider/constant";
import { MBContract } from "../../constants/insurance/constant";
import HomeIcon from "@mui/icons-material/Home";
import { checkSlaTime } from "../../services/provider/common";
import { actionTextActionMap } from "../centralOms/common/constants";

const ActionsData = ({
  nextActions,
  currentOrder,
  setConfirmRejectDialogVisibility,
  setAttendanceDialogVisibility,
  setDocUploadDialogVisibility,
  setAction,
  setCurrentOrder,
  allowedActions,
  slaField,
  slaHours,
}) => {
  const getNextStatus = (currentOrder) => {
    if (MBContract["PreEmployment"] === currentOrder.contractId && QCSTATE_PROVIDERS.includes(USER?.user?.providerId)) {
      return "ReportApprovalPendingByBranch";
    } else if (
      [MBContract["ESALES"], MBContract["PrePolicy"]].includes(currentOrder.contractId) &&
      !BRANCH_WHITELISTED_PROVIDERS.includes(USER.user.providerId) &&
      !["cat12", "cat 12", "Cat 2", "Cat2", "cat2", "cat 2"].includes(currentOrder.packageName.toLowerCase())
    ) {
      return "ReportApprovalPendingByBranch";
    } else {
      return "Submit";
    }
  };

  const actions = nextActions && nextActions.length ? [...new Set(nextActions.map((action) => action.action))] : null;
  const slaTime = checkSlaTime(currentOrder[slaField], slaHours);
  allowedActions = allowedActions?.length && allowedActions[0] == "Upload Documents" ? [getNextStatus(currentOrder)] : allowedActions;
  const applicableActions = actions && allowedActions ? actions.filter((value) => allowedActions.includes(value)) : null;

  const handleClickAction = (event, action, actionName) => {
    setAction(action);
    if (action == "Confirm" || action == "Reject") {
      setConfirmRejectDialogVisibility(true);
    } else if (action == "Upload Documents") {
      setAction(actionName);
      setDocUploadDialogVisibility(true);
    } else if (action == "Attended" || action == "NotAttended") {
      setAttendanceDialogVisibility(true);
    }
    setCurrentOrder(currentOrder);
  };

  return (
    <div>
      <div className="flex w-full">
        <div className="text-gray-500">{currentOrder.fulfillmentType === "Home_Visit" ? <HomeIcon /> : ""}</div>
        <div>{currentOrder.priorityId >= 2 ? <div className="bg-yellow-100 rounded text-xs px-2 py-1"> HNI </div> : ""}</div>
        {applicableActions && applicableActions?.length != 0 && (
          <div className="text-xs flex al-itm-bs">
            {applicableActions.map((action) => (
              <button
                className={
                  ["RejectedByProvider", "NotAttended"].includes(action)
                    ? "border border-red-400  hover:bg-red-600 hover:border-red-600 hover:text-gray-100 text-gray-900 font-semibold text-xxs text-center rounded-md py-1 px-3 text-xs cursor-pointer ml-2 mb-2"
                    : "border border-green-400  hover:bg-green-600 hover:border-green-600 hover:text-gray-100 text-gray-900 font-semibold text-xxs text-center rounded-md py-1 px-3 text-xs cursor-pointer ml-2 mb-2"
                }
                onClick={(event) => handleClickAction(event, actionTextActionMap[action], action)}
              >
                {actionTextActionMap[action]}
              </button>
            ))}
          </div>
        )}
      </div>
      {applicableActions &&applicableActions?.length != 0 && slaTime && (
        <div className="pt-1 text-center w-full font-normal mt-1 bg-red-100 rounded" style={{ fontSize: "12px" }}>
          <div className="animateSLACount">Action Pending Since</div>
          <div className="animateSLACount">
            {slaTime.month ? (
              <span>{slaTime.month} Month</span>
            ) : slaTime.day ? (
              <span>
                {slaTime.day} Day{slaTime.hour ? `s ${slaTime.hour} Hours` : ""}
              </span>
            ) : slaTime.hour ? (
              <span>{slaTime.hour} Hour</span>
            ) : (
              ""
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ActionsData;
